import { useSyncExternalStore } from 'react';
import { isAppOffline, subscribeConnectivity } from '../services/connectivity.service';

/**
 * Snapshot reader for the online flag.
 * @returns True when the app has a usable connection.
 */
function getSnapshot(): boolean {
  return !isAppOffline();
}

/**
 * Server snapshot used outside the browser; assumes online.
 * @returns Always true.
 */
function getServerSnapshot(): boolean {
  return true;
}

/**
 * React hook exposing whether the app currently has a usable internet connection —
 * combines the browser's online/offline events with real reachability checks
 * triggered by failed API calls.
 * @returns True when online, false when offline.
 */
export default function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribeConnectivity, getSnapshot, getServerSnapshot);
}
